import React from 'react';
import { Icon } from '@iconify-icon/react';

export function SuggestionIcon({ category, className }) {
    let SuggestionIcon;

    const activeClassName = className || '';

    switch (category?.toLowerCase()) {
        case 'restaurants':
            SuggestionIcon = (
                <Icon icon="fluent:food-16-regular" className={activeClassName} width="1.2rem" height="1.2rem" />
            );
            break;
        case 'churches':
            SuggestionIcon = (
                <Icon
                    icon="material-symbols:church-outline"
                    className={activeClassName}
                    width="1.3rem"
                    height="1.3rem"
                />
            );
            break;
        case 'zoos and acquariums':
            SuggestionIcon = (
                <Icon icon="icon-park-outline:dolphin" className={activeClassName} width="1.3rem" height="1.3rem" />
            );
            break;
        case 'night life':
            SuggestionIcon = (
                <Icon
                    icon="material-symbols:nightlife-rounded"
                    className={activeClassName}
                    width="1.3rem"
                    height="1.3rem"
                />
            );
            break;
        case 'natural parks':
            SuggestionIcon = <Icon icon="ph:park" className={activeClassName} width="1.3rem" height="1.3rem" />;
            break;
        default:
            SuggestionIcon = (
                <Icon
                    icon="material-symbols:account-balance-outline-rounded"
                    className={activeClassName}
                    width="1.1rem"
                    height="1.1rem"
                />
            );
    }

    return SuggestionIcon;
}
